import { Injectable, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';


@Injectable()
export class ScorecardConnectorService {

  // emit wne score details in the right nav selected
  // subscribe to this event in the segment for focusing on control
  @Output() scoreDetailsExpanded: EventEmitter<any> = new EventEmitter<any>();

  // control's score in the right nav hovered
  // subscribe to this event in the segment for highlighting control
  @Output() scorecardItemHovered: EventEmitter<any> = new EventEmitter<any>();

  // control's score in the right nav blured
  // subscribe to this event in the segment for unhighlighting control
  @Output() scorecardItemBlured: EventEmitter<any> = new EventEmitter<any>();

  // control focused
  // subscribe to this event in the scorecard for expandding score details
  @Output() controlFocused: EventEmitter<any> = new EventEmitter<any>();

  // control stauts changed (valid/invalid)
  // need to update score status in the scorecard details
  @Output() controlStatusChanged: EventEmitter<any> = new EventEmitter<any>();

  // control value has changed (1/0)
  // need to update score populated in the scorecard details
  @Output() controlPopulatedChanged: EventEmitter<any> = new EventEmitter<any>();

  // after control become valid/invalid
  // need to update total segment completeness percentage
  @Output() totalScoreChanged: EventEmitter<1|0> = new EventEmitter<1|0>();

  // control has been removed (in case of list of controls)
  // remove score related to the control
  @Output() controlRemoved: EventEmitter<any> = new EventEmitter<any>();

  // control has been added (in case of list of controls)
  // add score related to the control
  @Output() controlAdded: EventEmitter<any> = new EventEmitter<any>();

  // order of the scores has been changed
  // some segments have possibility to drag table rows
  @Output() scoresOrderChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() detectChangesInScorecard: EventEmitter<any> = new EventEmitter<any>();

  // tableRowCollapsed
  // subscribe to this event in the scorecard for collapsing score row
  // {index: number, collapsed: boolean}
  @Output() tableRowCollapsed: EventEmitter<any> = new EventEmitter<any>();

  // This event emitter is for scorecard-tab - to get all statuses for fields
  // in 'conditional' object - to update itself
  @Output() requireConditionalStatuses: EventEmitter<any> = new EventEmitter<any>();

  /*
    This event emitter is for scorecard-tab - segment sends 'required' values changes
    according to 'conditional' required data
    format example:
    {
      'packages.EA.quantity': true,
      'packages.EA.dimensions.height': false,
    }
  */
  @Output() conditionalRequiredDataChanged: EventEmitter<any> = new EventEmitter<any>();
}
